import React, { useState, useRef } from 'react';
import { Button, Rate, Input as AntInput } from 'antd';
import { PopConfirm } from '../../../hocs/PopConfirm/PopConfirm';

import styles from './index.module.css';

export const MarkFavoriteGoogleAddess = React.memo(
  ({
    form,
    field,
    name,
    orgId,
    id,
    currentAddressObj,
    insertFavoriteAddress,
    handleRemoveAddress,
    isFavoriteAddress = false,
  }) => {
    const textInput = useRef(null);
    const [open, setOpen] = useState(false);

    const openPopUp = () => {
      setOpen(true);
    };

    const popConfirmProps = isFavoriteAddress
      ? {
          title: 'Confirmation',
          description: 'Are you sure you want to delete this address?',
          onConfirm: () => handleRemoveAddress(id),
        }
      : {
          title: 'Location Name',
          description: <AntInput placeholder="Location Name" maxLength={12} ref={textInput} />,
          onConfirm: ({ user }) => {
            insertFavoriteAddress({
              location: currentAddressObj,
              title: textInput?.current?.input?.value,
            });

            if (textInput.current) {
              textInput.current.value = '';
            }

            setOpen(false);
          },
          onCancel: () => {
            setOpen(false);
          },
        };

    return (
      <PopConfirm {...popConfirmProps} open={open}>
        <Button
          type="text"
          htmlType="button"
          className={styles.favStarBtn}
          onClick={openPopUp}
          aria-label="Save address as favorite"
        >
          <Rate className={styles.favRate} count={1} value={open ? 1 : 0} disabled />
        </Button>
      </PopConfirm>
    );
  },
);
